// converting text from camel case
const toSnake = (key: string): string =>
  key.replace(/([a-z\d])([A-Z])/g, '$1_$2').toLowerCase();

type GenericObject = { [key: string]: unknown };

export default <T>(
  camelKey: string,
  value: T,
): [string, T | GenericObject[]] => {
  const snakeKey = toSnake(camelKey);

  if (!Array.isArray(value)) return [snakeKey, value];

  const nestedValue = value.map((payloadItem) => {
    if (!payloadItem || typeof payloadItem !== 'object')
      return payloadItem as T;
    return Object.entries(payloadItem as GenericObject).reduce(
      (acc: GenericObject, [payloadCamelKey, payloadValue]) => {
        acc[toSnake(payloadCamelKey)] = payloadValue;
        return acc;
      },
      {},
    );
  }) as GenericObject[];

  return [snakeKey, nestedValue];
};
